import { FC, useState } from 'react';

import { t } from 'i18next';

import { SearchDocument } from '@cfa/pathway-fe-shared/xp';

import { useBreakpointDown } from '@/hooks/useMediaQuery';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

import { IframeView } from '../common';

interface GameProps {
  document: SearchDocument;
}

const GameBetterOnLargeScreenConfirm = () => {
  const isBelowMd = useBreakpointDown('md');
  const [isDismissed, setIsDismissed] = useState(false);

  return (
    <ConfirmationModal
      bodyText={t('games.betterOnALargeScreenBody')}
      headerText={t('games.betterOnALargeScreenTitle')}
      isOpen={isBelowMd && !isDismissed}
      primaryButtonHandler={() => {
        setIsDismissed(true);
      }}
      onClose={() => {
        setIsDismissed(true);
      }}
      primaryButtonText={t('games.betterOnALargeScreenConfirm')}
    />
  );
};

/** Game document. */
const Game: FC<GameProps> = ({ document }) => (
  <>
    <GameBetterOnLargeScreenConfirm />
    <IframeView url={document.contentUrl} />
  </>
);

export default Game;
